import { Box, OutlinedInput } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Images } from "../../assets/common";
import cookieStorage from "../../services/cookie-storage";
import {
  formatedDate,
  getUserDetail,
  getUserId,
  truncate,
} from "./../../constants/function";
import { SocketContext } from "./../../context/socket";

import "./index.scss";
export default function ChatInput(props) {
  const [status, setStatus] = useState();
  const token = cookieStorage.getCookie("Authorization");
  const [loading, setLoading] = React.useState(false);
  const socket = useContext(SocketContext).Socket;

  const [message, setMessage] = React.useState("");
  const sendMessage = () => {
    if (message.trim() !== "") {
      const userData = getUserDetail();
      const msg = {
        roomId:
          props["roomId"] && props["type"] === "direct"
            ? props["roomId"]
            : props["playListId"],
        senderUserId: props["senderUserId"],
        message: message,
        _id: userData["_id"],
        JWT: token,
        isOpened: false,
      };
      setMessage("");
      if (props["type"] === "direct") socket.emit("send", msg);
      else socket.emit("chat_message", msg);

      msg["user"] = {
        firstName: userData["firstName"],
        lastName: userData["lastName"],
        profileImg: userData["profileImg"],
        _id: userData["_id"],
      };
      msg["_id"] = new Date().getTime();
      msg["createdAt"] = new Date();

      props.onSendMessage(msg);
      document.getElementById("_chat_box").focus();
    }
  };
  const handleEnterPress = (event) => {
    if (event.shiftKey && event.keyCode === 13) return;
    else if (event.keyCode === 13) {
      sendMessage();
    }
  };
  var typingTimer; //timer identifier
  var doneTypingInterval = 1000; //time in ms, 1 seconds for example

  const onKeyup = (event) => {
    setMessage(event.target.value);
    handleEnterPress(event);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping(event), doneTypingInterval);
  };
  const onkeydown = () => {
    clearTimeout(typingTimer);
  };
  //user is "finished typing," do something
  function doneTyping(e) {
    // console.log("Done");
    // socket.emit("typing", false);
    if (props["type"] === "direct") {
      socket.emit("directTyping", {
        senderUserId: getUserId(),
        roomId: props["roomId"],
        messageContent: e.target.value,
      });
    } else {
      socket.emit("typing", {
        senderUserId: getUserId(),
        messageContent: e.target.value,
        roomId: props["roomId"],
      });
    }

    //do something
  }

  useEffect(() => {
    if (props["message"].length) {
      setMessage((prevMsg) => prevMsg + props["message"]);
      if (props.cleanEmoji()) props.cleanEmoji();
    }
  }, [props["message"]]);
  useEffect(() => {
    if (props.status) setStatus(props.status);
    console.log(status);
  }, [props.status]);
  return (
    <Box
      sx={{
        display: "flex",
        width: "inherit",
      }}
    >
      <textarea
        id="_chat_box"
        rows="2"
        title={"Type message"}
        autoFocus
        className="__chat_input"
        type="text"
        value={message}
        placeholder="Type your message"
        onChange={(e) => {
          // socket.emit("typing", "");
          setMessage(e.target.value);

          // setShowUsers(false);
          // setOpenTip(false);
        }}
        onKeyUp={(e) => onKeyup(e)}
        onKeyDown={(e) => onkeydown(e)}
      />
      <img
        aria-label="send message"
        title={"send message"}
        className="__sent_botton"
        onClick={() => sendMessage()}
        src={message.trim() === "" ? Images.send : Images.send_active}
        alt="send"
      />
    </Box>
  );
}
